import { useState } from "react";
import { Play, LoaderCircle } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export function DemoEntry({ className }: { className?: string }) {
  const [busy, setBusy] = useState(false);
  async function enter() {
    setBusy(true);
    try {
      // Public, shared sample account. Never use these credentials for access checks.
      const { error } = await supabase.auth.signInWithPassword({
        email: "demo@wealthycreatives.co",
        password: "password",
      });
      if (error) throw error;
      window.location.assign("/dashboard");
    } catch {
      toast.error("The demo couldn't open. Please try again shortly.");
      setBusy(false);
    }
  }
  return (
    <Button type="button" variant="outline" onClick={enter} disabled={busy} className={className}>
      {busy ? <LoaderCircle className="animate-spin" /> : <Play />}
      {busy ? "Opening demo…" : "Explore the demo"}
    </Button>
  );
}